module.exports = __webpack_public_path__ + "img/ragequest-min.55c569ea.png";